/**
 * Обрезает текст до указанной длины и добавляет многоточие
 * @param {string} text - Текст для обрезки
 * @param {number} maxLength - Максимальная длина
 * @returns {string} Обрезанный текст
 */
export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};

/**
 * Преобразует первую букву в верхний регистр
 * @param {string} text - Текст для преобразования
 * @returns {string} Текст с заглавной первой буквой
 */
export const capitalize = (text) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};

/**
 * Преобразует текст в camelCase
 * @param {string} text - Текст для преобразования
 * @returns {string} Текст в camelCase
 */
export const toCamelCase = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());
};

/**
 * Преобразует текст в kebab-case
 * @param {string} text - Текст для преобразования
 * @returns {string} Текст в kebab-case
 */
export const toKebabCase = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

/**
 * Генерирует случайный ID
 * @param {number} length - Длина ID
 * @returns {string} Случайный ID
 */
export const generateId = (length = 8) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

/**
 * Проверяет, является ли строка пустой или содержит только пробелы
 * @param {string} text - Текст для проверки
 * @returns {boolean} true, если строка пустая
 */
export const isEmpty = (text) => {
  return !text || text.trim().length === 0;
}; 